export enum DropDownPosition {
  TOP = 'POSITION_TOP',
  BOTTOM = 'POSITION_BOTTOM'
}
export enum FILE_ACTION {
  ORIGINAL = 'ORIGINAL',
  ERRORS = 'ERRORS',
  UPLOAD = 'UPLOAD'
}
export enum FILE_STATUS {
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
  INITIATED = 'INITIATED',
  FAILED = 'FAILED'
}
export enum PURGEOPTIONS {
  YES = 'Yes',
  NO = 'No'
}
export enum UploadFileErrorMessage {
  TESSERACT_STEP = 'TESSERACT_STEP',
  UPLOAD_FILE = 'UPLOAD_FILE'
}
export type UploadFileResponse = {
  success: boolean;
  message: UploadFileErrorMessage | '';
  error: boolean;
};

export enum ErrMessages {
  UPLOAD = 'Column headers not as per Guidelines! Please review and upload again',
  DEFAULT_MESSAGE = 'Something went wrong while processing the file. Please try again'
}

export type Message = {
  error: boolean;
  success: boolean;
  message: ErrMessages | '';
};
